import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {Icon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

export const PauseIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const GapSVG = (
    <svg viewBox="0 0 8.093 18" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(1.125)">
        <path
          d="M.321,18H-1.125V0H.321Z"
          fill={isLight ? theme.color.wh : theme.color.b1}
          id="Left"
          transform="translate(0 0)"
        />
        <path
          d="M.321,17.749H-1.125V0H.321Z"
          fill={isLight ? theme.color.wh : theme.color.b1}
          id="Right"
          transform="translate(6.646 0)"
        />
      </g>
    </svg>
  );

  const brandIconSVGs = {
    [Brands.Athleta]: null,
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: GapSVG,
    [Brands.GapFactoryStore]: GapSVG,
    [Brands.OldNavy]: null,
    crossBrand: null,
  };
  return <Icon {...props} brandIconSVGs={brandIconSVGs} />;
};
